import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { createI18n } from "vue-i18n";
import messages from "./locales/messages";
import { createPinia } from "pinia";
import "./assets/scss/global.scss"; 
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

const i18n = createI18n({
  locale: "ar",
  fallbackLocale: "ar",
  messages,
});
const pinia = createPinia();

const app = createApp(App);
app.use(router);
app.use(i18n);
app.use(pinia);
app.use(ElementPlus);

// Mount only once the router has resolved the first navigation. That navigation is
// async (router.install() pushes without awaiting), so without this every setup()
// runs while route.query is still empty — which is why App/navbar/footer fell back
// to the stale localStorage product id and rendered another product's name.
router.isReady().then(() => {
  app.mount("#app");
});
